import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import InputWithExtra from '../../Comman/components/InputWithExtra';
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;
var isShowPassword = false;

class SMTPComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            EmailId: '',
            Password: '',
            Host: '',
            Port: '',
            IsEnableSSL: false,
            IsUseUserCredentials: false,
        }
        this.handleInput = this.handleInput.bind(this);
        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next", nextProps);
        if (nextProps.getAllEmailSettingData.Message != this.props.getAllEmailSettingData.Message) {
            if (nextProps.getAllEmailSettingData.statusCode == 200) {
                swal(nextProps.getAllEmailSettingData.Message, {
                    icon: "success",
                });
                this.props.getSMTPdata();
            }
        }
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }
    componentDidUpdate(prevProps) {
        if (prevProps.getAllEmailSettingData != this.props.getAllEmailSettingData) {
            if (this.props.getAllEmailSettingData.SMTPdetail) {
                let data = this.props.getAllEmailSettingData.SMTPdetail ? this.props.getAllEmailSettingData.SMTPdetail : null;
                this.setState({
                    EmailId: data.EmailId,
                    Password: data.Password,
                    Host: data.Host,
                    Port: data.Port,
                    IsEnableSSL: data.IsEnableSSL,
                    IsUseUserCredentials: data.IsUseUserCredentials
                })
            }
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }
    handleInput(e) {  
        let value = e.target.value;
        let name = e.target.name;
        this.setState({
            [name]: value
        })
    }
    toggleChange = () => {
        this.setState({
            IsUseUserCredentials: !this.state.IsUseUserCredentials
        });
    }
    toggleChange1 = () => {
        this.setState({
            IsEnableSSL: !this.state.IsEnableSSL
        });
    }
    showPassword = () => {
        alert("dvdsvsv")
        isShowPassword = !isShowPassword;
        console.log(isShowPassword)
    }
    save() {
        sleep(2000).then(() => {
            console.log(this.state);
        })
        let payload = this.state;
        if (this.validator.allValid()) {  
            this.props.addSMTPdetails(payload);
        }
        else {
            this.validator.showMessages(); 
            this.forceUpdate();
        }
    }
    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>SMTP {t('Menu.Setting')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="EmailId" className="form-label">{t('First_Responder.Email ID')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <InputWithExtra
                                                    type={'text'}
                                                    title="EmailId"
                                                    name={'EmailId'}
                                                    value={this.state.EmailId}
                                                    // placeholder={t('Email Setting.Subject')}
                                                    onChange = {this.handleInput}
                                                />
                                                {this.validator.message("EmailId", this.state.EmailId, 'required|email')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="Password" className="form-label">{t('First_Responder.Password')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <InputWithExtra
                                                    type={'text'}
                                                    title="Password"
                                                    name={'Password'}
                                                    value={this.state.Password}
                                                    // placeholder={t('Email Setting.Subject')}
                                                    onChange = {this.handleInput}
                                                />
                                                {/* <i class="fas fa-eye" className="hide-password"></i>
                                                <i class="fas fa-eye-slash" className="show-password"></i> */}
                                                {this.validator.message("Password", this.state.Password, 'required|min:6')}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                               
                                            </div>
                                            <div className="col-md-9">
                                                <label htmlFor="showPswd" className="form-label">Show Password</label>
                                                &nbsp;&nbsp;
                                                <input
                                                    name="showPswd"
                                                    onChange={() => this.showPassword()}
                                                    checked={isShowPassword}
                                                    type="checkbox"
                                                    value = "isShowPassword" />
                                                
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="Host" className="form-label">{t('Email Setting.Host')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <InputWithExtra
                                                    type={'text'}
                                                    title="Host"
                                                    name={'Host'}
                                                    value={this.state.Host}
                                                    // placeholder={t('Email Setting.Subject')}
                                                    onChange = {this.handleInput}
                                                />
                                                {this.validator.message("Host", this.state.Host, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="Port" className="form-label">{t('Email Setting.Port')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <InputWithExtra
                                                    type={'text'}
                                                    title="Port"
                                                    name={'Port'}
                                                    value={this.state.Port}
                                                    // placeholder={t('Email Setting.Subject')}
                                                    onChange = {this.handleInput}
                                                />
                                                {this.validator.message("Port", this.state.Port, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="IsEnableSSL" className="form-label">{t('Email Setting.Is Enable SSL')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input
                                                    name="IsEnableSSL"
                                                    onChange={() => this.toggleChange1()}
                                                    checked={this.state.IsEnableSSL}
                                                    type="checkbox" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="IsUseUserCredentials" className="form-label">{t('Email Setting.Is Use User Credentials')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input
                                                    name="IsUseUserCredentials"
                                                    onChange={() => this.toggleChange()}
                                                    checked={this.state.IsUseUserCredentials}
                                                    type="checkbox" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={() => { this.save() }}
                                                    disabled={this.props.getAllEmailSettingData.isLoading == true}
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>
                                                {
                                                    this.props.getAllEmailSettingData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(SMTPComponent));
